import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  Business as RecruiterIcon,
  Person as CandidateIcon,
  RecordVoiceOver as InterviewIcon,
  Handshake as HireIcon,
} from '@mui/icons-material';
import { HERO_FLOW_NODES } from '../landingContent';
import { LANDING_COLORS, LANDING_FONTS } from '../landingVisual';

const NODE_ICONS = {
  recruiter: RecruiterIcon,
  candidate: CandidateIcon,
  interview: InterviewIcon,
  hire: HireIcon,
};

const HeroFlowVisual = () => (
  <Box
    sx={{
      mt: { xs: 6, md: 7 },
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: { xs: 1.25, sm: 0 },
      fontFamily: LANDING_FONTS.sans,
    }}
    aria-label="Career flow: Candidate to Interview to Hire to Recruiter"
  >
    {HERO_FLOW_NODES.map((node, index) => {
      const Icon = NODE_ICONS[node.key];
      return (
        <React.Fragment key={node.key}>
          <Box
            className="fade-in"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 1,
              animationDelay: `${index * 0.12}s`,
              px: { xs: 1.5, sm: 2.25 },
              py: 1.5,
              minWidth: 88,
            }}
          >
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: 1.5,
                bgcolor: LANDING_COLORS.mistDeep,
                border: `1px solid ${LANDING_COLORS.line}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Icon sx={{ color: LANDING_COLORS.accent, fontSize: 22 }} aria-hidden="true" />
            </Box>
            <Typography
              variant="caption"
              sx={{ color: LANDING_COLORS.ink, fontWeight: 600, letterSpacing: '0.02em' }}
            >
              {node.label}
            </Typography>
          </Box>
          {index < HERO_FLOW_NODES.length - 1 && (
            <Box
              aria-hidden
              sx={{
                alignSelf: 'center',
                width: { xs: 0, sm: 28 },
                height: 1,
                bgcolor: LANDING_COLORS.line,
                display: { xs: 'none', sm: 'block' },
                mx: 0.25,
              }}
            />
          )}
        </React.Fragment>
      );
    })}
  </Box>
);

export default HeroFlowVisual;
